export default {"src":"/_next/static/media/speedAnalyzerSmallGray.96d9f7dc.svg","height":65,"width":136};